import React from 'react'
import clsx from 'clsx'
import { getCurrencySybol } from 'sdk/utils/currency';
import { formatAssetStat } from 'sdk/utils/formatValues';
import styles from './AssetValue.module.scss';

function AssetValue({ asset, className, ...props }: {
  asset: any,
  className?: string,
  lastPrice?: any
}) {
  const isOpenMarket = asset?.quote?.is_market_open

  let oldPrice = asset?.quote?.previous_close || 0

  if (isOpenMarket === false && typeof asset?.quote?.close === 'number') {
    oldPrice = Number(asset?.quote?.close);
  }
  const lastPrice = props?.lastPrice || asset?.latest_price?.price || 0
  const delta = lastPrice - oldPrice
  const deltaPercent = (+oldPrice) ? ((delta / oldPrice) * 100) : 0

  return (
    <div className={clsx(styles.catValueCol, className)}>
      <div className={styles.catValue}>
        {`${getCurrencySybol(asset?.currency_name)} 
        ${formatAssetStat(lastPrice)}`}
      </div>
      <div className={clsx(styles.catPercent, (delta < 0) && styles.catPercentRed)}>
        {`${(delta >= 0) ? '+' : '-'}${formatAssetStat(Math.abs(deltaPercent))}%`}
      </div>
    </div>
  )
}

export default AssetValue
